var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('Preparing'),(_vm.isLoading == false)?_c('Footer',{attrs:{"eulaurl":_vm.eulaurl,"contactusurl":_vm.contactusurl,"companyurl":_vm.companyurl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }